import type { FC, MouseEventHandler } from 'react';

import { getDocsDockControlsStyle } from '../styles/docsProvider.styles';
import { DocsCollapseButton } from './DocsCollapseButton';
import { DocsOpenInNewTabButton } from './DocsOpenInNewTabButton';

export type DocsDockControlsProps = {
  onClose: MouseEventHandler<HTMLButtonElement>;
  onOpenInNewTab: MouseEventHandler<HTMLButtonElement>;
};

export const DocsDockControls: FC<DocsDockControlsProps> = ({ onClose, onOpenInNewTab }) => (
  <div style={getDocsDockControlsStyle()} data-test="docs-dock-controls">
    <DocsCollapseButton onClick={onClose} />
    <DocsOpenInNewTabButton onClick={onOpenInNewTab} />
  </div>
);
